import React from 'react'
import CardUI from '../../../widgets/layout/CardUI'
import FormSF from '../../../widgets/form/FormSF'
import InputTextSF from '../../../widgets/form/InputTextSF'

const AccountNameUpdateUI = ({context, accountName,
    messageList, successMsg, errorList, accountNameError,
    submitted,
    // event handlers
    onSubmit, onCancel, setErrorList, onAccountNameChange, setAccountNameError
  }) =>
  <CardUI context={context}>
    <FormSF context={context}
      messageList={messageList} buttonMessageKey='c_update' cancelMessageKey='c_cancel'
      successMsg={successMsg} errorList={errorList}
      busy={submitted} onSubmit={onSubmit} onCancel={onCancel} setErrorList={setErrorList}
    >
      <InputTextSF type='text' name='accountName' required={true} maxLength={40}
        messageList={messageList} labelKey='c_account_name'
        value={accountName} error={accountNameError} onChange={onAccountNameChange} setError={setAccountNameError}
        autoFocus={true}
      />
    </FormSF>
  </CardUI>

export default AccountNameUpdateUI
